// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import ListaReservas from '../../../componentesEspeciales/reserva/listaReservas';
// estilos
import '../../../estilos/usuario.css';



function ReservasComprador() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
   // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);
    const [reservas, setReservas]  = useState([]);
    const [servicios, setServicios] = useState([]);
    const [paginaActual, setPaginaActual] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const RESERVAS_POR_PAGINA = 5;


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
           // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const resReservas = await axios.post("/obtener-todas-reservas", {
                    params: {
                        idUsuario: usuario.idUsuario,
                        tipo: "COMPRADOR",
                        pagina: paginaActual,
                        limite: RESERVAS_POR_PAGINA,
                        desdeDonde: "reservas",
                    }
                });

                //console.log("resReservas: ", resReservas);
                const reservasAusar = resReservas?.data?.reservas || [];
                const serviciosAusar = resReservas?.data?.servicios || [];
                const totalPaginasRespuesta = resReservas?.data?.paginacion?.totalPaginas || 1;

                setReservas(reservasAusar);
                setServicios(serviciosAusar);
                setTotalPaginas(totalPaginasRespuesta);
            }
            finally { setCargando(false); }
        })();
    }, [usuario, cargandoUsuario, paginaActual, navigate]);
    



    //console.log("reservas: ", reservas);
 
 


    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Reservas</h1>
                    </div>
                </div>
            </div>


            {/* RESERVAS */}
            {!reservas ? null : <ListaReservas reservas={reservas} servicios={servicios} usuario={usuario} quienEs={"Comprador"} />}
            


            {/* PAGINACIÓN */}
            <div className="container mt-4">
                <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                    <button
                        className="btn btn-outline-primary rounded-pill px-4"
                        onClick={() => setPaginaActual((prev) => Math.max(prev - 1, 1))}
                        disabled={paginaActual === 1}
                    >
                        Anterior
                    </button>

                    <span className="fw-bold text-dark">
                        Página {paginaActual}
                    </span>

                    <button
                        className="btn btn-outline-primary rounded-pill px-4"
                        onClick={() => setPaginaActual((prev) => Math.min(prev + 1, totalPaginas))}
                        disabled={paginaActual >= totalPaginas}
                    >
                        Siguiente
                    </button>
                </div>
            </div>
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default ReservasComprador;